import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import { telegramClientApi } from '@/shared';
import { GetFriendsResponseType } from '@/entities';

export interface FriendsState {
  data: GetFriendsResponseType | null;
  loading: boolean;
  error: string | null;
}

const initialState: FriendsState = {
  data: null,
  loading: false,
  error: null
};

export const fetchFriends = createAsyncThunk<
  GetFriendsResponseType,
  { offset?: number; limit?: number },
  { rejectValue: string }
>('friends/fetchFriends', async (_, { rejectWithValue }) => {
  try {
    const res = await telegramClientApi.getFriends();

    if (res.error === null && res.data) {
      return res.data;
    } else if (res.error !== null) {
      return rejectWithValue(res.error.message);
    }

    return rejectWithValue('Unknown error occurred');
  } catch (error) {
    return rejectWithValue((error as Error).message);
  }
});

const friendsSlice = createSlice({
  name: 'friends',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchFriends.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchFriends.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchFriends.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to fetch friends';
      });
  }
});

export default friendsSlice.reducer;
